<astral-input
  [label]="caption"
  [helpText]="helpText"
  [value]="value"
  [readonly]="true"
  [type]="fieldType === 'phone' ? 'phone' : fieldType === 'email' ? 'email' : 'text'"
></astral-input>
